import bestNetwork_fr from './bestNetwork/fr.json';
import bestNetwork_en from './bestNetwork/en.json';
import bestNetwork_de from './bestNetwork/de.json';
import bestNetwork_it from './bestNetwork/it.json';
import bestNetwork_es from './bestNetwork/es.json';
import bestNetwork_zh from './bestNetwork/zh.json';
import bestPlatform_fr from './bestPlatform/fr.json';
import bestPlatform_en from './bestPlatform/en.json';
import bestPlatform_de from './bestPlatform/de.json';
import bestPlatform_it from './bestPlatform/it.json';
import bestPlatform_es from './bestPlatform/es.json';
import bestPlatform_zh from './bestPlatform/zh.json';
import comparison_fr from './comparison/fr.json';
import comparison_en from './comparison/en.json';
import comparison_de from './comparison/de.json';
import comparison_it from './comparison/it.json';
import comparison_es from './comparison/es.json';
import comparison_zh from './comparison/zh.json';
import cpaMonetization_fr from './cpaMonetization/fr.json';
import cpaMonetization_en from './cpaMonetization/en.json';
import cpaMonetization_de from './cpaMonetization/de.json';
import cpaMonetization_it from './cpaMonetization/it.json';
import cpaMonetization_es from './cpaMonetization/es.json';
import cpaMonetization_zh from './cpaMonetization/zh.json';
import ecommerceAffiliation_fr from './ecommerceAffiliation/fr.json';
import ecommerceAffiliation_en from './ecommerceAffiliation/en.json';
import ecommerceAffiliation_de from './ecommerceAffiliation/de.json';
import ecommerceAffiliation_it from './ecommerceAffiliation/it.json';
import ecommerceAffiliation_es from './ecommerceAffiliation/es.json';
import ecommerceAffiliation_zh from './ecommerceAffiliation/zh.json';

const seoContent = {
  bestNetwork: { fr: bestNetwork_fr, en: bestNetwork_en, de: bestNetwork_de, it: bestNetwork_it, es: bestNetwork_es, zh: bestNetwork_zh },
  bestPlatform: { fr: bestPlatform_fr, en: bestPlatform_en, de: bestPlatform_de, it: bestPlatform_it, es: bestPlatform_es, zh: bestPlatform_zh },
  comparison: { fr: comparison_fr, en: comparison_en, de: comparison_de, it: comparison_it, es: comparison_es, zh: comparison_zh },
  cpaMonetization: { fr: cpaMonetization_fr, en: cpaMonetization_en, de: cpaMonetization_de, it: cpaMonetization_it, es: cpaMonetization_es, zh: cpaMonetization_zh },
  ecommerceAffiliation: { fr: ecommerceAffiliation_fr, en: ecommerceAffiliation_en, de: ecommerceAffiliation_de, it: ecommerceAffiliation_it, es: ecommerceAffiliation_es, zh: ecommerceAffiliation_zh },
};

export default seoContent;
